import React, {useMemo, useEffect} from 'react';
import {connect} from 'react-redux';
import OrganizationDashboard from './components/OrganizationDashboard/OrganizationDashboard';
import {getContactCompanyList, getOrganizationsDataForCompanies} from '../PortalsBlock/portalSlice';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';

const BusinessDashboardMain = ({
  contentData,
  isLoading,
  isOrgDataLoading,
  isFullAuthenticated,
  isCompanyListReqCompleted,
  privateCompanyList,
  getContactCompanyList,
  getOrganizationsDataForCompanies,
  showAppLoader,
  hideAppLoader,
}) => {
  useEffect(() => {
    if (isFullAuthenticated && !isLoading && !isCompanyListReqCompleted) {
      getContactCompanyList();
    }
  }, [isFullAuthenticated]);

  useEffect(() => {
    if (isCompanyListReqCompleted && privateCompanyList?.length > 0) {
      getOrganizationsDataForCompanies(privateCompanyList);
    }
  }, [isCompanyListReqCompleted]);

  useEffect(() => {
    if (isLoading || isOrgDataLoading) {
      showAppLoader();
    } else {
      hideAppLoader();
    }
  }, [isLoading, isOrgDataLoading]);

  const renderCurrentStep = useMemo(() => {
    const isReady = isFullAuthenticated && isCompanyListReqCompleted && !isOrgDataLoading;
    if (!isReady) {
      return null;
    }
    return <OrganizationDashboard contentData={contentData} />;
  }, [isFullAuthenticated, isCompanyListReqCompleted, isOrgDataLoading]);

  return (
    <div className='business-dashboard-main'>
      {renderCurrentStep}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
  isLoading: state.portalsBlock.isLoading,
  isOrgDataLoading: state.portalsBlock.isOrgDataLoading,
  isCompanyListReqCompleted: state.portalsBlock.requestCompleted,
  privateCompanyList: state.portalsBlock.privateCompanyList,
});

const mapDispatchToProps = {
  getContactCompanyList,
  getOrganizationsDataForCompanies,
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(BusinessDashboardMain));
